<template>
  <main-layout>
      <div class="mealSuc">
          <div class="sucBox">
              <div class="imgBox">
                  <img src="/static/live/pay_done_icon@2x.png" alt="">订单已提交！
              </div>
              <div class="price">待支付：<i>¥{{price}}</i></div>
              <p class="title">请向以下账户对公转账，我们将在确认贵司订单支付款项后的1个工作日内为您开通套餐</p>
              <div class="titleBox">
                  <p>收款名称：上海吗呐网络科技有限公司</p>
                  <p>收款账号：31050173460000000053</p>
                  <p>开户行：中国建设银行股份有限公司上海长桥支行</p>
              </div>
              <div class="but" @click="gotoOrder">查看订单</div>
          </div>
      </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
export default {
  metaInfo() {
    return {
      title: "MANA " + this.$t('recruit.招聘'),
    };
  },
  components: {
    MainLayout,
  },
  data() {
    return {
        price: 0
    };
  },

  methods: {
    gotoOrder() {
        this.$router.push("/my/order");
    }
  },

  created() {
    if (this.$query.price) {
        this.price = this.$query.price;
    }
  },
  mounted() {},
};
</script>
<style lang="stylus" scoped>
.mealSuc{
    padding-top: 80px;
    background: #fff;
    min-height: 70vh;
    .sucBox{
        width: 600px;
        margin: 0 auto;
        text-align: center;
        .imgBox{
            text-align: center;
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            line-height: 42px;
            img{
                width: 50px;
                height: 50px;
                vertical-align: middle;
                margin-right: 12px;
            }
        }
        .price{
            margin: 20px 0;
            font-size: 16px;
            font-weight: 400;
            color: #0A0A0A;
            height: 36px;
            line-height: 36px;
            i{
                font-size: 24px;
                font-weight: 500;
                color: #FC6240;
            }
        }
        .title{
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            margin-bottom: 20px;
        }
        .titleBox{
            p{
                font-size: 16px;
                font-weight: 600;
                color: #333333;
                line-height: 32px;
            }
        }
        .but{
            margin: 50px auto 0;
            width: 144px;
            height: 40px;
            line-height: 40px;
            background: #2026CC;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            text-align: center;
            cursor: pointer;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/newLive/mealSuc.vue